export default {
  addMember: 'Add new member',
  contractTitle: '{{packageTypeName}} - Select Contracts',
  contractorJoiningScheduled: 'Joining Scheduled',
  draftOnly: 'Draft only',
  emptyWithAction: "Can't find any workers?",
  error: 'An error occurred',
  errorDescription: 'An error occurred while fetching data.',
  excludeRequested: 'Show not-yet-requested / already archived only',
  hasFamily: 'Has family',
  joinedThisYear: 'Joined this year',
  joiningScheduled: 'Joining Scheduled',
  leaveKindFilter: {
    CHILDCARE_LEAVE: 'Childcare leave',
    MATERNITY_LEAVE: 'Maternity leave',
    NURSING_CARE_LEAVE: 'Nursing care leave',
    OTHER: 'Other leave',
    SICK_LEAVE: 'Sick leave',
    label: 'Leave type'
  },
  missingPackageInfo: 'Package information not found',
  missingPackageInfoDescription: 'Please select a package before accessing this page.',
  myNumberCollectedOnly: 'My Number collected only',
  nextStep: 'Next',
  notSupported: 'This feature is not supported',
  notSupportedDescription: 'The target selection feature is not available for the selected package type.',
  personalNumber: {
    collectAction: 'Start collection for all uncollected members',
    collected: 'Collected',
    deselectAction: 'Deselect uncollected members',
    notCollected: 'Not collected',
    uncollectedDescription: 'Some members have no My Number on file. Employment insurance filings submitted without one may be returned.'
  },
  requestStatus: {
    ABORTED: 'Archived',
    COMPLETED: 'Completed',
    IN_PROGRESS: 'In progress',
    NOT_REQUESTED: 'Not requested'
  },
  searchContractPlaceholder: 'Search by contractor name',
  searchPlaceholder: 'Search by name or email',
  selectedContractCount: '{{count}} contracts selected',
  selectedCount: '{{count}} selected',
  startedTargetsFilter: {
    IN_PROGRESS: 'Exclude awaiting response',
    IN_PROGRESS_OR_COMPLETED: 'Exclude awaiting and responded',
    NONE: 'Show all',
    label: 'Response status'
  },
  title: '{{packageTypeName}} - Select Targets'
};